
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-search-line',
      title: 'Avaliação e Análise de Precatórios',
      description: 'Avaliação detalhada e análise completa do seu precatório para garantir a melhor proposta do mercado.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Assessoria e Consultoria Jurídica Especializada',
      description: 'Assessoria jurídica especializada com acompanhamento em todas as etapas do processo.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Cessão e Compra de Direitos Creditórios',
      description: 'Operações seguras de cessão e compra de direitos creditórios com total transparência.'
    }
  ];

  return (
    <section id="servicos" className="py-20 bg-blue-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Nossos Serviços
          </h2>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: 'Open Sans, sans-serif' }}>
            Oferecemos soluções completas para a venda do seu precatório com total segurança e transparência.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-blue-900 rounded-lg flex items-center justify-center mb-6 mx-auto">
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-blue-900 mb-4 text-center" style={{ fontFamily: 'Poppins, sans-serif' }}>
                {service.title}
              </h3>
              <p className="text-gray-600 text-center leading-relaxed" style={{ fontFamily: 'Open Sans, sans-serif' }}>
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
